import kimchiImg from '../images/kimchi.jpg';
import binggraeMelon from '../images/binggrae-melon.jpg';
import binggraeStrawberry from '../images/binggrae-strawberry.jpg';
import binggraeBanana from '../images/binggrae-banana.jpg';
import fishCake from '../images/fish-cake.jpg';

const addons = [
    {
        'itemId': 'kimchi_200g',
        'itemName': 'Kimchi',
        'itemSubtitle': '200 grams',
        'itemPrice': 100,
        'itemPromo': '',
        'itemImg': kimchiImg
    },
    {
        'itemId': 'kimchi_500g',
        'itemName': 'Kimchi',
        'itemSubtitle': '500 grams',
        'itemPrice': 200,
        'itemPromo': '',
        'itemImg': kimchiImg
    },
    {
        'itemId': 'fishcake_50g',
        'itemName': 'Fish Cake',
        'itemSubtitle': '50 grams',
        'itemPrice': 35,
        'itemPromo': '',
        'itemImg': fishCake
    },
    {
        'itemId': 'binggrae_melon',
        'itemName': 'Binggrae Melon',
        'itemSubtitle': '1pc',
        'itemPrice': 65,
        'itemPromo': '',
        'itemImg': binggraeMelon
    },
    {
        'itemId': 'binggrae_strawberry',
        'itemName': 'Binggrae Strawberry',
        'itemSubtitle': '1pc',
        'itemPrice': 65,
        'itemPromo': '',
        'itemImg': binggraeStrawberry
    },
    {
        'itemId': 'binggrae_banana',
        'itemName': 'Binggrae Banana',
        'itemSubtitle': '1pc',
        'itemPrice': 65,
        'itemPromo': '',
        'itemImg': binggraeBanana
    },
]

export default addons;